import { InjectionToken } from '@angular/core'
import { MultiRegionApiConfiguration } from './multi-region-api-configuration'
import { ServerConfiguration } from './server-configuration'
import { SocketConfiguration } from './socket-configuration'

export const API_CONFIGURATION = new InjectionToken<FullApiClientConfiguration>('API_CONFIGURATION')

export interface FullApiClientConfiguration {
  annotationsApi: MultiRegionApiConfiguration
  regionalApi: MultiRegionApiConfiguration
  playbackApi: MultiRegionApiConfiguration
  restApi: MultiRegionApiConfiguration
  courtUploaderServer: MultiRegionApiConfiguration
  digitalJusticeApi: MultiRegionApiConfiguration
  digitalJusticeWeb: MultiRegionApiConfiguration
  auditApi: MultiRegionApiConfiguration
  reportingApi: MultiRegionApiConfiguration
  distributionApi: MultiRegionApiConfiguration
  server: ServerConfiguration
  socket: SocketConfiguration
  globalAdminUrl: string
  webAppUrl: string
  courtsAppUrl: string
  publicAppUrl: string
  mockAuthUrl?: string
  recaptchaPublicKey: string // Could probably be moved to a separate configuration object if we had more non-api related config values, but for now it is easier to keep it here
}
